<template>
    <div v-if="inputVal">
        <student-worksheet-module-wrapper
            :module="module"
            :module-complete="response.module_complete"
            :worksheet-complete="worksheetComplete"
        >
            <div class="px-8">
                <div class="my-4 flex gap-4">
                    <div class="flex-grow">
                        <range-slider
                            :range-is-correct="response.module_complete"
                            :type="module.content.type"
                            :step="module.content.step"
                            :unit-label="module.content.unit_label"
                            :min="module.content.range.min"
                            :max="module.content.range.max"
                            v-model="rangeSelection"
                        ></range-slider>
                    </div>
                </div>
            </div>
        </student-worksheet-module-wrapper>
    </div>
</template>

<script>
import StudentWorksheetModuleWrapper from "@/Components/StudentWorksheetModuleWrapper";
import RangeSlider from "@/Components/RangeSlider";

export default {
    name: "StudentWorksheetModuleRange",
    props: ["modelValue", "module", "worksheetComplete"],
    components: {
        StudentWorksheetModuleWrapper,
        RangeSlider,
    },
    data() {
        return {
            response: {},
            rangeSelection: null,
        };
    },
    mounted() {
        if (!this.modelValue) {
            this.response = {
                answer_min: this.module.content.range.min,
                answer_max: this.module.content.range.max,
                module_complete: false,
            };

            this.rangeSelection = {
                min: this.module.content.range.min,
                max: this.module.content.range.max,
            };
        } else {
            this.response = {
                min: this.modelValue.answer_min,
                max: this.modelValue.answer_max,
                module_complete: this.modelValue.module_complete,
            };

            this.rangeSelection = {
                min: this.modelValue.min,
                max: this.modelValue.max,
            };

            this.checkAnswer();
        }

        this.inputVal = this.response;
    },
    methods: {
        checkAnswer: function () {
            return new Promise((resolve, reject) => {
                let vm = this;
                let wasCorrect = false;
                let answerMin = 0;
                let answerMax = 0;

                if (
                    typeof this.module.content.answer === "number" ||
                    typeof this.module.content.answer === "string"
                ) {
                    let singleAnswer = _.clone(this.module.content.answer);
                    this.module.content.answer = {
                        min: 0,
                        max: 0,
                    };
                    this.module.content.answer.min = singleAnswer;
                    this.module.content.answer.max = singleAnswer;
                }

                answerMin = parseFloat(this.module.content.answer.min);
                answerMax = parseFloat(this.module.content.answer.max);

                if (this.module.content.type === "single") {
                    if (answerMin === vm.rangeSelection.min) {
                        wasCorrect = true;
                    }
                } else {
                    if (
                        answerMin === vm.rangeSelection.min &&
                        answerMax === vm.rangeSelection.max
                    ) {
                        wasCorrect = true;
                    }
                }

                resolve(wasCorrect);
            });
        },
    },
    watch: {
        rangeSelection: {
            handler: _.debounce(function (val) {
                let vm = this;

                this.checkAnswer().then(function (wasCorrect) {
                    vm.response = {
                        min: vm.rangeSelection.min,
                        max: vm.rangeSelection.max,
                        module_complete: wasCorrect,
                    };

                    vm.inputVal = vm.response;

                    vm.$forceUpdate();
                });
            }, 300),
            deep: true,
        },
    },
    computed: {
        inputVal: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit("update:modelValue", val);
            },
        },
    },
};
</script>

<style scoped lang="postcss"></style>
